import navite from './native-bridge'
import { EventBus } from "./event-bus.js";

var ReportType = {
  REPORT_CREATE_ROLE: 1, //创角上报
  REPORT_UPDATE_ROLE: 2, //角色升级
  REPORT_ENTER_GAME: 3, //进入游戏
  REPORT_SPLASH_START: 11, //闪屏开始
  REPORT_SPLASH_FINISH: 12, //闪屏结束
  REPORT_LOADING_START: 13, //加载游戏资源开始
  REPORT_LOADING_FINISH: 14, //加载游戏资源完成
  REPORT_LOGIN_PAGE: 15, //进入登录页时
  REPORT_ERROR_LOG: -1, //上报异常日志
}

// 红包版判断
var red_packet_v = 0
var has_red_packet = false

var hasInit = 0

// 用户角色信息
var role_info = {}

function receMessage(event) {
  var info = event.data.data;
  switch (event.data.msg_type) {
    case "itx_login":
      hasInit = 1
      window.TXPARAMS = info.params
      window.TXLOGINHISTORY = info.tx_login_history ? JSON.parse(info.tx_login_history) : [];
      window.TXID = info.tx_id;
      window.TXTOKEN = info.tx_token;
      //跳转至登录前，为了便于统计，先调用一下初始化及激活接口(先调初始化后激活，保持与原生一致的逻辑)
      //初始化
      window.action.requestInit()
        .then((res) => {
          if (res.data.has_red_packet) {
            red_packet_v = res.data.has_red_packet
            window.red_packet_v = red_packet_v
          }
          //激活上报
          window.action.requestStart()
            .then(() => {
              login(info);
            })
            .catch(() => {
              console.log("激活上报接口失败");
            });
        })
        .catch(() => {
          console.log("初始化接口失败");
        });
      break;
    case "itx_logout":
      window.eventEmitter.emit("event_logout");
      break;
    case "itx_pay":
      var payData = Object.assign({}, info)
      payData.red_packet_v = red_packet_v
      payData.pay_from = 2;
      payData = convertParams(payData);
      payData = Object.assign(payData, role_info);
      window.payInfo = payData;
      window.router.replace("/pay");
      setTimeout(() => {
        EventBus.$emit("event_pay_data", payData)
      }, 100);
      break;
    case "itx_realname":
      window.action.requestRealNameSwitch({ type: info.type })
        .then(res => {
          let resData = res.data
          if (resData.is_pop === 1) {
            window.router.replace({ path: "/realname", query: { must: resData.is_must, type: info.type } });
          } else if (resData.is_pop === 0) {
            // 不需要实名认证
            window.eventEmitter.emit("event_realname", info);
          }
        })
        .catch(() => {
          window.eventEmitter.emit("event_realname", null);
        })
      break;
    case "itx_native_realname":
      window.router.replace({ path: "/realname", query: { must: info.is_must, type: info.type } });
      break;
    case "itx_native_realname2":
      window.action.requestRealNameSwitch({ type: 'login' })
        .then(res => {
          let resData = res.data
          if (resData.is_pop === 1) {
            window.router.replace({ path: "/realname", query: { must: resData.is_must, type: 'login' } });
          } else if (resData.is_pop === 0) {
            // 不需要实名认证
            window.eventEmitter.emit("event_realname", { type: 'login' });
          }
        }).catch(() => {
          window.eventEmitter.emit("event_realname", null);
        })
      break;
    case "itx_redEnvelope":
      role_info.red_packet_v = red_packet_v
      window.router.replace({ path: "/redEnvelope" });
      setTimeout(() => {
        EventBus.$emit("event_redEnvelope_data", role_info);
      }, 100);
      break;
    case "itx_report":
      role_info = info
      try {
        if (!has_red_packet && red_packet_v != 0 && info.server_key && info.role_id) {
          has_red_packet = true
          sendMessage({ msg_type: "callback_redEnvelope" })
        }
        if (info.data_type == ReportType.REPORT_CREATE_ROLE) {
          window.action.requestRoleCreate(info);
        } else if (info.data_type == ReportType.REPORT_UPDATE_ROLE) {
          window.action.requestRoleUpgrade(info);
        } else if (info.data_type == ReportType.REPORT_ENTER_GAME) {
          window.action.requestEnterGame(info);
        } else if (info.data_type == ReportType.REPORT_ERROR_LOG) {
          window.action.requestLog(info);
        }
      } catch (e) {
        console.log("reportData异常：" + JSON.stringify(e))
      }
      break;
    case "itx_navtive":
      navite.nativeCall(info);
      break;
    case "itx_error":
      window.router.replace({ path: "/error", query: { msg: encodeURIComponent(info.msg) } })
      break;
    default:
      break;
  }
}
function login(info) {
  if (window.router) {
    //login页面跳转
    if (info.tx_id && info.tx_token) {
      window.router.replace("/autoLogin");
    } else {
      window.router.replace("/login");
    }
  } else {
    setTimeout(() => {
      login(info)
    }, 1000);
  }
}

// 订单参数进行转换
function convertParams(params) {
  if (params.role_id == undefined || params.role_id == "") {
    params.role_id = params.roleId;
  }
  if (params.role_name == undefined || params.role_name == "") {
    params.role_name = params.roleName;
  }
  if (params.role_level == undefined || params.role_level == "") {
    params.role_level = params.roleLevel;
  }
  if (params.server_key == undefined || params.server_key == "") {
    params.server_key = params.serverId;
  }
  if (params.server_name == undefined || params.server_name == "") {
    params.server_name = params.serverName;
  }
  if (params.product_name == undefined || params.product_name == "") {
    params.product_name = params.productName;
  }
  if (params.product_value == undefined || params.product_value == "") {
    params.product_value = params.productValue;
  }
  if (params.cp_order_id == undefined || params.cp_order_id == "") {
    params.cp_order_id = params.tradeNo;
  }
  return params;
}

function sendMessage(data) {
  try {
    window.parent.postMessage(data, "*");
    if (data.msg_type != 'callback_sdk_pop_win') {
      window.router.replace("/");
    }
  } catch (e) {
    console.log("发送消息异常：" + JSON.stringify(e))
  }
}

setTimeout(function () {
  if (hasInit == 0) {
    sendMessage({ msg_type: 'callback_again_login' })
  }
}, 500)

export default {
  receMessage,
  sendMessage
}



// WEBPACK FOOTER //
// ./src/common/message.js